
// You can write more code here

/* START OF COMPILED CODE */

import TrapImage from "../TrapImage";
/* START-USER-IMPORTS */
import { BodyTypes } from "../../LevelManager";
/* END-USER-IMPORTS */

export default class TrapSpikes extends TrapImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 47.5, y ?? 34, texture || 'game-all', frame ?? "spikes.png");

    // this (prefab fields)
    this.zIndex = 300;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  public init() {
    let rect = this.scene.matter.bodies.rectangle(this.x, this.y, this.displayWidth - 20, this.displayHeight, {
      label: BodyTypes.TouchTrap,
      isStatic: true,
      onCollideCallback: super.onCollision.bind(this)
    });
    this.setExistingBody(rect);

    super.init();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
